import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";

const downloadSalesCampaign = (format: "excel" | "csv", searchParams: URLSearchParams) => {
  const apiUrl = occUrl(`/salescampaign/download/${format}`);
  const url = `${apiUrl}?${searchParams.toString()}`;

  return occFetch(url, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};

// The sales-campaign download API uses the same selected params as the search call.
export const downloadSalesCampaignExcel = (searchParams: URLSearchParams) =>
  downloadSalesCampaign("excel", searchParams);

export const downloadSalesCampaignCsv = (searchParams: URLSearchParams) => downloadSalesCampaign("csv", searchParams);
